<app-sistema-menu></app-sistema-menu>
<a id="redirect" routerLink="{{path}}"></a>

<section style="padding: 1em;">

    <div class="field is-grouped">
        <div class="control has-icons-left is-expanded">
            <input type="text" class="input is-flat is-medium" placeholder="Buscar" [(ngModel)]="busqueda" id="search-box">
            <span class="icon is-medium is-left">
                <i class="icon-search3"></i>
            </span>
        </div>
        <p class="control">
            <button class="button is-medium is-primary" [ngClass]="{ 'is-disabled': busqueda==''}" (click)="busqueda=''">
                <span class="icon">
                    <i class="fa fa-close"></i>
                </span>
            </button>
        </p>
    </div>
</section>
<section style="padding: 1em; overflow:auto;" [style.maxHeight.px]="tamano-130" class="index">
    <section class="contenedor columns is-multiline is-mobile" *ngFor="let val of menu;">
        <div *ngFor="let item of val.lista | buscarModulo: busqueda; let i = index" [ngClass]="item.lista ? 'column is-12' : val.lista.length-tiene < 6 ? 'column' : 'column is-2-desktop is-4-tablet is-6-mobile'">
            <a *ngIf="!item.lista" href="javascript:void(0)" title="{{ item.titulo}}" style="position: relative;" class="item menu-index menu-index-a "
                (click)="abrirLista(item)" routerLinkActive="active">

                <figure class="image " style="height: auto; width: 100%; ">
                    <i class="{{item.icono}}" style="font-size: 100px"></i>
                </figure>
                <span class="is-hidden-mobile">
                  <strong>{{ item.titulo}}</strong>
                  <a href="javascript:void(0)" class="button" (click)="abrirNuevo(item)"><i class="icon-file"></i></a>
                </span>
                <span class="is-hidden-tablet is-hidden-desktop">
                    <small>{{ item.titulo}}</small>
                    <a href="javascript:void(0)" class="button" (click)="abrirNuevo(item)"><i class="icon-file"></i></a>
                </span>
            </a>
            <span *ngIf="item.lista" class="menu-index-span column is-2-desktop is-4-tablet is-6-mobile">
                <figure class="image " style="height: auto; width: 100%; ">
                    <i class="{{item.icono}}" style="font-size: 100px"></i>
                </figure>
                <span class="is-hidden-mobile">{{ item.titulo}}</span>
                <span class="is-hidden-tablet is-hidden-desktop">
                    <small>{{ item.titulo}}</small>
                </span>
            </span>
            <!-- comentado para descartar los modulos que no tienen permisos -->
            <!-- <section *ngIf="item.lista" class="contenedor columns is-multiline is-mobile">
                <div *ngFor="let valor of item.lista | buscarModulo: busqueda;" [ngInit]="tiene_hijos()" class="menu-index menu-index-second"
                [ngClass]="item.lista.length < 6 ? 'column' : 'column is-2-desktop is-4-tablet is-12-mobile'">
                    <a href="javascript:void(0)" title="{{ valor.titulo}}" style="position: relative;" class="item" (click)="abrirLista(valor)" routerLinkActive="active">

                        <figure class="image " style="height: auto; width: 100%; ">
                            <i class="{{valor.icono}}" style="font-size: 100px"></i>
                        </figure>
                        <span class="is-hidden-mobile">
                          <strong> {{ valor.titulo}} </strong>
                          <a href="javascript:void(0)" class="button" (click)="abrirNuevo(valor)"><i class="icon-file"></i></a>
                        </span>
                        <span class="is-hidden-tablet is-hidden-desktop">
                            <small>  {{ valor.titulo}} </small>
                            <a href="javascript:void(0)" class="button" (click)="abrirNuevo(valor)"><i class="icon-file"></i></a>
                        </span>
                    </a>
                </div>
            </section> -->

            <section *ngIf="item.lista" class="contenedor columns is-multiline is-mobile">
                <ng-container *ngFor="let valor of item.lista | buscarModulo: busqueda;"> 
                    <div *ngIf="permisos.indexOf(valor.key)> -1"  [ngInit]="tiene_hijos()" class="menu-index menu-index-second"
                        [ngClass]="item.lista.length < 6 ? 'column' : 'column is-2-desktop is-4-tablet is-12-mobile'">
                            <a href="javascript:void(0)" title="{{ valor.titulo}}" style="position: relative;" class="item" (click)="abrirLista(valor)" routerLinkActive="active">
        
                                <figure class="image " style="height: auto; width: 100%; ">
                                    <i class="{{valor.icono}}" style="font-size: 100px"></i>
                                </figure>
                                <span class="is-hidden-mobile">
                                  <strong> {{ valor.titulo}} </strong>
                                  <a href="javascript:void(0)" class="button" (click)="abrirNuevo(valor)"><i class="icon-file"></i></a>
                                </span>
                                <span class="is-hidden-tablet is-hidden-desktop">
                                    <small>  {{ valor.titulo}} </small>
                                    <a href="javascript:void(0)" class="button" (click)="abrirNuevo(valor)"><i class="icon-file"></i></a>
                                </span>
                            </a>
                        </div>
                </ng-container>
            </section>
            <hr *ngIf="item.lista">
        </div>
        <hr>
    </section>
</section>
